<template>
	<v-row justify="center">
		<div class="card">
			<div
				class="head"
				data-aos="fade-up"
				:class="MIXIN_SETUP_UI.header"
			>
				{{ title }}
			</div>
			<p
				class="text-center"
				v-if="caption"
				data-aos="fade-up"
			>
				{{ caption }}
			</p>
		</div>
	</v-row>
</template>

<script>
	export default {
		props: {
			title: { type: String, default: '' },
			caption: { type: String },
			// size: { type: String, default: '2' },
		}
	}
</script>

<style lang="scss" scoped>
.card {
	padding-left: 15%;
	padding-right: 15%;
}
</style>